export default __webpack_public_path__ + "static/media/640_business05-it-mobile.1fa376a2.png";